export default "__VITE_ASSET__Ea8ea$e7__"